@if (card(); as card) {
  @if (['unknown', 'visa'].includes(card.brand)) {
    <img src="/assets/icons/cards/visa.svg" alt="" />
  } @else if (['unknown', 'amex'].includes(card.brand)) {
    <img src="/assets/icons/cards/amex.svg" alt="" />
  } @else if (['unknown', 'mastercard'].includes(card.brand)) {
    <img src="/assets/icons/cards/mastercard.svg" alt="" />
  } @else if (['discover'].includes(card.brand)) {
    <img src="/assets/icons/cards/discover.svg" alt="" />
  } @else if (['diners'].includes(card.brand)) {
    <img src="/assets/icons/cards/diners.svg" alt="" />
  }
}

<div class="number">
  ••••
  @if (card(); as card) {
    {{ card.last4 }}
  }
</div>

<button
  appButton
  name="update"
  location="checkout-existing-card"
  color="simple-gray"
  height="0"
  spacing="1"
  (click)="update.emit()"
>
  Update
</button>
